const data_tab_data = [
  {
    id: 0,
    title: "Datasets",
    path: "/data/datasets",
  },
  {
    id: 1,
    title: "Models",
    path: "/data/models",
  },
  {
    id: 2,
    title: "Workers",
    //When we create config component here we need to change path
    path: "/data/workers",
  },
  {
    id: 3,
    title: "Config",
    path: "/data/config",
  },
];

export default data_tab_data;
